module.exports = __webpack_public_path__ + "media/8.22846ee6.wav";